import { createGlobalStyle } from "styled-components"

const GlobalStyles  = createGlobalStyle`
    *{
        box-sizing: border-box;
    }

    body{
        background: ${({theme}) => theme.colors.bgColor};
        transition: all 0.5s 0s ease;
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }
`

export default GlobalStyles

